module.exports = __webpack_public_path__ + "static/fanwood_text_italic-webfont-f610fd2493c3246c49f36858e8dc9dae.woff";